import BaseReducer from "./BaseReducer";

class SessionModalReducer extends BaseReducer {
  domain = "Modals";
  type = "SessionModal";

  initialState = {
    open: false,
  };
}

const reducer = new SessionModalReducer();

export default reducer;
